// import { TGetAccessRefreshTokenPayload, TVerifyEmailResponsePayload } from 'types/auth';
import CustomApi from './base/custom-api';

class AuthApi extends CustomApi {
  constructor(baseURL: string) {
    super(baseURL);

    this.axios.interceptors.request.use(
      (config: any) => {
        config.headers = {
          ...config.headers,
          'api-key': process.env.REACT_APP_NEW_API_KEY,
        };
        return config;
      },
      (error: any) => Promise.reject(error),
    );
  }
}

export default new AuthApi(process.env.REACT_APP_NEW_AUTH_API_URL || '');
